import { connect } from "react-redux";
import { compose } from "redux";

import { getTeamMatches } from "./actions";
import {
  makeSelectIsError,
  makeSelectIsReady,
  makeSelectTeamMatches,
} from "./reducer";
import Component from "./teamMatches";

const makeMapStateToProps = () => {
  const selectTeamMatches = makeSelectTeamMatches();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    matches: selectTeamMatches(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetTeamMatches: (data) => dispatch(getTeamMatches(data)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
